window.site = (window.site || {});

/**
 * Main application class.
 * @class App
 * @static
 */
window.site.App = (function App() {
  /**
   * Has the class been initialized?
   * @private
   */
  let inited = false;

  /**
   * Application config defaults.
   * @private
   * @param config.env     Current server environment
   * @param config.csrf    Security token to submit with forms
   * @param config.locale  Current locale short code
   * @param config.device  Device detection based on browser signature
   * @param config.preview Page is shown through live preview mode
   * @param config.general Settings from general config
   */
  const config = {
    env: 'production',
    csrf: null,
    locale: 'en',
    device: 'desktop',
    preview: false,
    general: {},
  };

  /**
   * Initializes the class.
   * @public
   */
  const init = function init(options) {
    // Abort if already initialized
    if (inited) {
      return false;
    }

    inited = true;

    // Store application settings
    options = (options || {});

    if (options.env) { config.env = options.env; }
    if (options.csrf) { config.csrf = options.csrf; }
    if (options.locale) { config.locale = options.locale; }
    if (options.device) { config.device = options.device; }
    if (options.preview) { config.preview = options.preview; }
    if (options.general) { config.general = options.general; }

    // Initialize child classes
    if (typeof site.scrollTo === 'object') {site.scrollTo.init();}
    if (typeof site.ShareButton === 'object') {site.ShareButton.init();}
    if (typeof site.Map === 'object') {site.Map.init();}
    if (typeof site.AjaxPagination === 'object') {site.AjaxPagination.init();}
    if (typeof site.OffersGalleries === 'object') {site.OffersGalleries.init();}
    if (typeof site.HeroSwitch === 'object') {site.HeroSwitch.init();}
    if (typeof site.SpacesOffice === 'object') {site.SpacesOffice.init();}
    if (typeof site.AboutPage === 'object') {site.AboutPage.init();}
    if (typeof site.SpacesGalleries === 'object') {site.SpacesGalleries.init();}
    if (typeof site.OffersSpaceGalleries === 'object') {site.OffersSpaceGalleries.init();}
    if (typeof site.HallItemGalleries === 'object') {site.HallItemGalleries.init();}
    if (typeof site.SmoothScrolling === 'object') {site.SmoothScrolling.init();}
    if (typeof site.MenuMobile === 'object') {site.MenuMobile.init();}
    if (typeof site.YoutubeVideo === 'object') {site.YoutubeVideo.init();}
    if (typeof site.BlogFilter === 'object') {site.BlogFilter.init();}
    if (typeof site.sidePanel === 'object') {site.sidePanel.init();}
    if (typeof site.BookARoom === 'object') {site.BookARoom.init();}

    console.table(options);

    // Return success
    return true;
  };

  /**
   * Getter for application config.
   * @public
   */
  const getConfig = function getConfig(option) {
    return config[option] ? config[option] : false;
  };

  /**
   * Expose public methods & properties.
   */
  return {
    init,
    config: getConfig,
  };
}());
